/** Кнопка прямого скачивания PDF общего плана без промежуточных окон. */
import { useState } from "react";
import { toast } from "react-toastify";
import { UIKit } from "@/shared/ui";
import { useProjectStore } from "@/shared/store";
import { useEditorStore, ViewMode } from "@/widgets/editor";
import { downloadPdfExport } from "../logic";
import type { ExportSettings } from "../types";
import { ExportOptionsModal } from "./ExportOptionsModal";

interface Props {
	/** Кнопка в мобильном списке команд: выше и с подписью. */
	mobile?: boolean;
}

export const ExportDialog = ({ mobile = false }: Props) => {
	const [exporting, setExporting] = useState(false);
	const [optionsOpen, setOptionsOpen] = useState(false);
	const project = useProjectStore((state) => state.project);
	const startExport = async (settings: ExportSettings) => {
		setOptionsOpen(false);
		setExporting(true);
		useEditorStore.getState().setViewMode(ViewMode.TwoD);
		//Костыль чтобы печатать 2D из любого режима
		await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));
		try {
			await downloadPdfExport(project, settings);
		} catch (error) {
			console.error("Не удалось экспортировать PDF", error);
			toast.error("Не удалось собрать PDF. Подробности — в консоли браузера.");
		} finally {
			setExporting(false);
		}
	};

	return (
		<>
			{mobile ? (
				<UIKit.IconButton
					className="h-18 gap-1"
					icon={<UIKit.IconPrint />}
					label={exporting ? "Готовим PDF..." : "Экспортировать"}
					disabled={exporting}
					onClick={() => setOptionsOpen(true)}
				/>
			) : (
				<UIKit.ToolButton
					icon={<UIKit.IconPrint />}
					label={exporting ? "Готовим PDF..." : "Экспортировать"}
					disabled={exporting}
					onClick={() => setOptionsOpen(true)}
				/>
			)}
			{optionsOpen && (
				<ExportOptionsModal onClose={() => setOptionsOpen(false)} onExport={startExport} />
			)}
		</>
	);
};
